import { auth, db, storage } from "../../../firebase/config";
import {
  collection,
  getDocs,
} from "firebase/firestore";

export function getLeads(userAvlUID) {
    return getDocs(collection(db, userAvlUID))
  }